import React from "react";
import "./SummaryCharts.css";

const count = (value) => Number.isFinite(Number(value)) && Number(value) > 0 ? Number(value) : 0;
const percent = (value, total) => total ? `${(value / total * 100).toLocaleString(undefined, { maximumFractionDigits: 1 })}%` : "0%";

export function DonutChart({ series, label, centreLabel = "records", emptyMessage = "No data to display." }) {
  const items = series.map((item) => ({ ...item, value: count(item.value) }));
  const total = items.reduce((sum, item) => sum + item.value, 0);
  let offset = 0;
  return (
    <div className="glyder-donut">
      <svg viewBox="0 0 200 200" role="img" aria-label={`${label}: ${total} ${centreLabel}`}>
        <title>{label}: {items.map((item) => `${item.label} ${item.value}`).join(", ")}</title>
        <circle cx="100" cy="100" r="76" fill="none" stroke="#e8eef1" strokeWidth="24" />
        {items.filter((item) => item.value > 0).map((item) => {
          const length = item.value / total * 100;
          const start = offset;
          offset += length;
          return <circle key={item.label} cx="100" cy="100" r="76" fill="none" stroke={item.color}
            strokeWidth="24" pathLength="100" strokeDasharray={`${length} ${100 - length}`}
            strokeDashoffset={-start} transform="rotate(-90 100 100)">
            <title>{item.label}: {item.value} ({percent(item.value, total)})</title>
          </circle>;
        })}
        <text x="100" y="101" textAnchor="middle" className="glyder-donut-total">{total.toLocaleString()}</text>
        <text x="100" y="123" textAnchor="middle" className="glyder-donut-label">{centreLabel}</text>
      </svg>
      <div className="glyder-donut-key">
        {!total && <p className="glyder-chart-note">{emptyMessage}</p>}
        <ul aria-label={`${label} breakdown`}>
          {items.map((item) => <li key={item.label}>
            <span className="glyder-chart-dot" style={{ background: item.color }} aria-hidden="true" />
            <span className="glyder-chart-category">{item.label}</span>
            <strong>{item.value.toLocaleString()}</strong>
            <span className="glyder-chart-percent">{percent(item.value, total)}</span>
          </li>)}
        </ul>
      </div>
    </div>
  );
}

export function BarChart({ series, label, emptyMessage = "No items need attention." }) {
  const maximum = Math.max(1, ...series.map((item) => count(item.value)));
  return <div className="glyder-bars">
    {series.every((item) => !count(item.value)) && <p className="glyder-chart-note">{emptyMessage}</p>}
    <ul aria-label={label}>
      {series.map((item) => <li key={item.label}>
        <div className="glyder-bar-caption"><span>{item.label}</span><strong>{count(item.value).toLocaleString()}</strong></div>
        <div className="glyder-bar-track" aria-hidden="true"><div style={{ width: `${count(item.value) / maximum * 100}%`, background: item.color }} /></div>
      </li>)}
    </ul>
  </div>;
}
